import React from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"

type propType = {
    configValue: string
  }
const Notes = ({configValue}: propType) => {
    return (
        <Page padding={false}>
            <Panel hasFooter={false} noHeader className="notes-container">
                <Block dangerouslySetInnerHTML={{ __html: configValue }} />
            </Panel>
        </Page>
    )
}

export default Notes
